import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { IconDone } from "../icons/IconDone/IconDone.mjs";
import { useMenuItem } from "../MenuItem/useMenuItem.mjs";
import { checkboxBorder, checkboxPadding } from "./MenuItemCheckbox.css.mjs";
const MenuItemCheckbox = ({
  children,
  onChange,
  checked,
  data,
  badge,
  id
}) => {
  const { menuItemProps, MenuItemChildren } = useMenuItem({
    onClick: () => onChange(!checked),
    formElement: true,
    data,
    id
  });
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...menuItemProps,
      "aria-checked": checked,
      role: "menuitemcheckbox",
      component: "button",
      type: "button",
      display: "flex",
      alignItems: "center",
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            component: "span",
            borderRadius: "standard",
            boxShadow: "borderField",
            position: "relative",
            background: { lightMode: "surface" },
            marginRight: "xsmall",
            flexShrink: 0,
            className: checkboxBorder,
            children: /* @__PURE__ */ jsx(
              Box,
              {
                component: "span",
                position: "absolute",
                width: "full",
                height: "full",
                background: "formAccent",
                borderRadius: "standard",
                transition: "fast",
                opacity: checked ? void 0 : 0,
                className: checkboxPadding,
                children: /* @__PURE__ */ jsx(IconDone, { size: "fill" })
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(MenuItemChildren, { tone: void 0, icon: void 0, badge, formElement: true, children })
      ]
    }
  );
};
MenuItemCheckbox.__isMenuItem__ = true;
export {
  MenuItemCheckbox
};
